export default __webpack_public_path__ + "static/media/template-hd1.9241bf5d.png";